import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Plus, X, UserPlus, Users, CalendarOff, Briefcase, ClipboardPlus
} from 'lucide-react';

const ACTIONS = [
  { key: 'reservation', label: 'Nouvelle réservation', icon: ClipboardPlus, path: '/company/planning?action=new-booking', color: 'bg-purple-500' },
  { key: 'client', label: 'Nouveau client', icon: UserPlus, path: '/company/clients?action=new', color: 'bg-emerald-500' },
  { key: 'collaborator', label: 'Nouveau collaborateur', icon: Users, path: '/company/collaborators?action=new', color: 'bg-amber-500' },
  { key: 'closure', label: 'Nouvelle fermeture', icon: CalendarOff, path: '/company/closures?action=new', color: 'bg-orange-500' },
  { key: 'service', label: 'Nouveau service', icon: Briefcase, path: '/company/services?action=new', color: 'bg-teal-500' },
];

export default function QuickActionFab() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const fabRef = useRef(null);

  // Close on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (fabRef.current && !fabRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <div ref={fabRef} className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3" data-testid="quick-action-fab">
      {/* Action items */}
      {open && (
        <div className="flex flex-col items-end gap-2 mb-2 animate-in fade-in slide-in-from-bottom-2 duration-200">
          {ACTIONS.map((action) => (
            <button
              key={action.key}
              type="button"
              onClick={() => { navigate(action.path); setOpen(false); }}
              data-testid={`fab-action-${action.key}`}
              className="group flex items-center gap-3 bg-white shadow-lg hover:shadow-xl border border-border pl-4 pr-2 py-2 rounded-full transition-all hover:translate-x-[-2px]"
            >
              <span className="text-sm font-medium text-foreground whitespace-nowrap">{action.label}</span>
              <span className={`w-9 h-9 rounded-full flex items-center justify-center text-white ${action.color} shadow-sm`}>
                <action.icon className="w-4 h-4" />
              </span>
            </button>
          ))}
        </div>
      )}

      {/* Main FAB button */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="fab-toggle"
        aria-label={open ? 'Fermer le menu rapide' : 'Ouvrir le menu rapide'}
        className={`w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-xl hover:shadow-2xl flex items-center justify-center transition-all ${
          open ? 'rotate-45' : 'hover:scale-105'
        }`}
      >
        {open ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
      </button>
    </div>
  );
}
